import axiosInstance from "./AxiosInstance";

const BASE_URL = "/api/v3/parking/recaudo/";

export const FacturacionService = {
  getRecaudo: (params = {}) => {
    return axiosInstance.get(BASE_URL, { params });
  },

  getTotales: (params = {}) => {
    return axiosInstance.get(`${BASE_URL}totales/`, { params });
  },

  getRecaudoPorUrl: (url) => {
    return axiosInstance.get(url);
  },

  exportRecaudo: (params = {}) => {
    return axiosInstance.get(`${BASE_URL}export/`, { params });
  },

  getNotasRecaudo: (params = {}) => {
    return axiosInstance.get("/api/v3/vigilancia/visitantes-comentarios/", {
      params,
    });
  },
};

export default FacturacionService;
